/* eslint-disable */
import * as types from '../../actions/types';

const initialState = {
  data: {},
  loading: false
}

export default function files (state = initialState, action) {
  switch (action.type) {
    
    case types.SET_QUESTIONS_FILES:
      return {
        ...state,
        data: {...state.data, ...action.payload}
      }
    
    case types.SET_QUESTIONS_FILES_LOADING:
      return {
        ...state,
        loading: action.payload
      }
    
    default:
      return state;
  }
}